import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAnalytics } from '../context/AnalyticsContext';
import './Landing.css';

const Team: React.FC = () => {
  const { trackPageView } = useAnalytics();

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  useEffect(() => {
    trackPageView('/team', 'Team');
  }, [trackPageView]);

  return (
    <div className="app">
      <Header />
      
      {/* Main Content */}
      <main className="main-content">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-content">
            <h1 className="hero-title">Meet Our Team</h1>
            <p className="hero-subtitle">
              We're parents who understand the challenges of summer camp scheduling firsthand
            </p>
          </div>
        </section>

        {/* Team Content */}
        <section className="team-content">
          <div className="content-container">
            <div className="team-intro">
              <h2>Our Story</h2>
              <p>
                As busy parents ourselves, we experienced the frustration and time-consuming nature of scheduling summer camps for our children. 
                We saw how families were spending countless hours researching, comparing, and coordinating camp schedules across multiple spreadsheets 
                and communication channels. That's why we created Aika - to make summer camp planning easier, more efficient, and less stressful for families everywhere.
              </p>
            </div>

            <div className="team-grid">
              <div className="team-member">
                <img src="/images/jenni-ojala.jpg" alt="Jenni Ojala" className="member-photo" />
                <h3 className="member-name">Jenni Ojala</h3>
                <p className="member-title">CEO & Co-Founder</p>
                <div className="member-bio">
                  <p>
                    Jenni brings over 15 years of experience in product management and business strategy. 
                    As a mom of three, Jenni knows the daily chaos of family schedules, and that’s what sparked the idea for Aika. She’s on a mission to make parents’ lives easier by using technology to take the stress out of planning.
                  </p>
                  <p>
                    Prior to founding Aika, Jenni led teams at several fintech and enterprise technology companies, 
                    where she developed a passion for creating user-centered solutions that solve real problems. 
                    She’s led global teams, managed multimillion-dollar client projects, and built solutions used by millions of end users.
                  </p>
                  <p>
                  Jenni studied Industrial Management and Computer Science at Aalto University and completed executive leadership studies at Stanford Graduate School of Business. 
                    Outside of work, you can find her skiing or hiking the Colorado Rockies with her family and singing in a community choir.
                  </p>
                </div>
              </div>

              <div className="team-member">
                <img src="/images/klaus-ihlberg.jpg" alt="Klaus Ihlberg" className="member-photo" />
                <h3 className="member-name">Klaus Ihlberg</h3>
                <p className="member-title">CTO & Co-Founder</p>
                <div className="member-bio">
                  <p>
                  Klaus has spent his career leading engineering teams and building software at global companies, but his favorite role is being a dad. With years of experience balancing demanding work with family life, he knows how tricky it can be for parents to juggle schedules and commitments. That perspective is what drew him to Aika’s mission.
                  </p>
                  <p>
                  Before co-founding Aika, Klaus held senior leadership roles at Chainalysis and Atlassian, where he led teams through large-scale platform transformations and product launches. He has led global teams across fintech, SaaS, and enterprise software, always with a focus on building solutions that make a real impact.
                  </p>
                  <p>
                  Klaus holds a Master’s degree in Computer Science from Aalto University and has lived and worked across Europe, Australia, and the U.S. Outside of work, he’s passionate about Brazilian Jiu-Jitsu, cooking, and snowboarding with his family.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Team;
